import SalesOrders from './SalesOrders';

export default SalesOrders;
